module.exports = __webpack_public_path__ + "static/media/17.7b8ddb4c.svg";